<template>
  <b-modal
    :visible="visible"
    title="И-баримт бүртгэл дэлгэрэнгүй"
    size="lg"
    ok-only
    ok-title="Хаах"
    @hidden="$emit('update:visible', false)"
  >
    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>

    <b-alert
      v-else-if="errorMessage"
      show
      variant="danger"
      class="p-1"
    >
      {{ errorMessage }}
    </b-alert>

    <div v-else-if="detail">
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Дугаар:</b-col>
        <b-col cols="8">{{ detail.id }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Харилцагчийн ID:</b-col>
        <b-col cols="8">{{ detail.customer_id }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Зээлийн дансны ID:</b-col>
        <b-col cols="8">{{ detail.loan_account_id }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Trigger төрөл:</b-col>
        <b-col cols="8">{{ detail.trigger_type }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Хугацаа:</b-col>
        <b-col cols="8">{{ detail.due_date }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Нийт дүн:</b-col>
        <b-col cols="8">{{ formatCurrency(detail.total_amount) }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Төлөв:</b-col>
        <b-col cols="8">
          <b-badge pill :variant="`light-${resolveStatusVariant(detail.status)}`">
            {{ detail.status }}
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">ДДТД:</b-col>
        <b-col cols="8">{{ detail.ddtd || '-' }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col cols="4" class="font-weight-bold">Баримт олгосон огноо:</b-col>
        <b-col cols="8">{{ detail.ebarimt_date || '-' }}</b-col>
      </b-row>
      <b-row v-if="detail.error_code || detail.error_message" class="mb-1">
        <b-col cols="4" class="font-weight-bold">Алдаа:</b-col>
        <b-col cols="8">
          <span v-if="detail.error_code">[{{ detail.error_code }}] </span>{{ detail.error_message }}
        </b-col>
      </b-row>

      <hr>
      <h6 class="font-weight-bold mb-1">Орлогын төрлөөр задаргаа</h6>
      <b-table
        v-if="detail.lines && detail.lines.length"
        :items="detail.lines"
        :fields="lineFields"
        small
        responsive
      >
        <template #cell(income_type)="data">
          {{ resolveIncomeTypeLabel(data.item.income_type) }}
        </template>
        <template #cell(amount)="data">
          {{ formatCurrency(data.item.amount) }}
        </template>
      </b-table>
      <p v-else class="text-muted">
        Задаргаа алга байна
      </p>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BRow, BCol, BBadge, BSpinner, BAlert, BTable,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import { formatCurrency } from '@core/utils/filter'
import store from '@/store'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BBadge,
    BSpinner,
    BAlert,
    BTable,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    entryId: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props) {
    const detail = ref(null)
    const loading = ref(false)
    const errorMessage = ref('')

    const lineFields = [
      { key: 'income_type', label: 'Орлогын төрөл' },
      { key: 'amount', label: 'Дүн' },
    ]

    const resolveStatusVariant = status => {
      const normalized = (status || '').toLowerCase()
      if (normalized === 'sent' || normalized === 'success') return 'success'
      if (normalized === 'pending') return 'warning'
      if (normalized === 'failed' || normalized === 'error') return 'danger'
      return 'primary'
    }

    const resolveIncomeTypeLabel = incomeType => {
      if (incomeType === 'DISBURSEMENT_FEE') return 'Олголтын шимтгэл'
      if (incomeType === 'BASE_INTEREST') return 'Үндсэн хүү'
      if (incomeType === 'PENALTY_INTEREST') return 'Нэмэгдүүлсэн хүү'
      return incomeType
    }

    const fetchDetail = () => {
      if (!props.entryId) return
      detail.value = null
      errorMessage.value = ''
      loading.value = true
      store
        .dispatch('app-loan-ebarimt/fetchLoanEbarimtDetail', { entry_id: props.entryId })
        .then(response => {
          detail.value = response.data
        })
        .catch(error => {
          if (error?.response?.status === 404) {
            errorMessage.value = 'Бүртгэл олдсонгүй'
          } else {
            errorMessage.value = 'Дэлгэрэнгүй мэдээлэл татахад алдаа гарлаа'
          }
        })
        .finally(() => {
          loading.value = false
        })
    }

    watch(() => props.visible, val => {
      if (val) fetchDetail()
    })

    return {
      detail,
      loading,
      errorMessage,
      lineFields,
      formatCurrency,
      resolveStatusVariant,
      resolveIncomeTypeLabel,
    }
  },
}
</script>
